import * as React from 'react';
import { classNames } from '@wix/answers-lib';
import { Icon } from '@wix/answers-ui-libby';
import { searchQuestionIcon } from './search-question-icon';
export var QuestionComponent = function (props) {
    var question = props.value.question;
    // Construct the Wix support search URL with the question as the search term
    var searchUrl = "https://support.wix.com/en/search?term=".concat(encodeURIComponent(question));
    return (React.createElement("div", { className: classNames('component', 'question-component'), "data-component-type": 'question' },
        React.createElement("div", { className: 'search-icon' },
            React.createElement(Icon, { icon: searchQuestionIcon })),
        React.createElement("a", { href: searchUrl, className: 'question-link', target: "_self", rel: "noopener noreferrer" }, question)));
};
//# sourceMappingURL=question-component.comp.js.map